__webpack_require__.p = "/dev/930-refactor-labelsvg-in-order-to-simplify-the-css-style-managm/";